// src/components/LuckBar.js
import React from "react";
import "./LuckBar.css";

const LuckBar = ({ luck, mode }) => {
  // Mode-specific messages
  const modeMessage =
    mode === "momentum"
      ? "⚡ Momentum Mode: Channeling luck into victories."
      : "🛡️ Stabilization Mode: Redirecting fate to protect and preserve.";

  // Select fill color and glow based on mode
  const fillColor = mode === "momentum" ? "#a855f7" : "#3b82f6";
  const barGlowClass = mode === "momentum" ? "momentum-glow" : "stabilization-glow";

  return (
    <div className={`luck-bar-container p-4 rounded-lg ${barGlowClass}`}>
      <p className="text-center font-semibold text-white mb-2">{modeMessage}</p>
      <div className="w-full h-4 rounded-full bg-gray-300 overflow-hidden relative">
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{
            width: `${luck}%`,
            backgroundColor: fillColor,
          }}
        ></div>
      </div>
    </div>
  );
};

export default LuckBar;
